angular.module('editingCenterServiceModule').service('editingCenterSaveCheckService', [
    'editingCenterService',
    '$q',
    'modalDialog',
    'ueditorService',
    'heimaCheckService',
    'messagePublishService',
    function (editingCenterService, $q, modalDialog, ueditorService, heimaCheckService, messagePublishService) {
        return {
            check($scope) {
                const defer = $q.defer();
                imgCheckForUeditor($scope)
                    .then(() => {
                        defer.resolve([])
                    })
                    .catch(() => {
                        angular.element('html,body').animate(
                            {
                                scrollTop: angular.element('.bigFaceDetailLeft').offset().top - angular.element('body').height() / 2,
                            },
                            'slow',
                        );
                        defer.reject([]);
                    });
                // imgCheckForUeditor($scope)
                //     .then((

                //     ) => trsCheckOfFangcun($scope))
                //     .then((data) => {
                //         defer.resolve(data);
                //     }).catch((data) => {
                //         angular.element('html,body').animate(
                //             {
                //                 scrollTop: angular.element('.bigFaceDetailLeft').offset().top - angular.element('body').height() / 2,
                //             },
                //             'slow',
                //         );
                //         defer.reject([]);
                //     });
                return defer.promise;
            }
        };

        /**
         * [trsCheckOfFangcun description]
         * @param   {[type]}  $scope  [data description]
         * @return  {[type]}        [return description]
         */
        // function trsCheckOfFangcun($scope) {
        //     return new Promise(function (resolve, reject) {
        //         editingCenterService.isXJRB().then(() => {
        //             if (window.UE) {
        //                 const doctype = editingCenterService.getDocType();
        //                 if (doctype === '新闻') {
        //                     heimaCheckService.makeFuncunCheck().then((data) => {
        //                         if (data.heimaWords.length) {
        //                             modalDialog.alertType('文章校对', '检测到正文中有疑似错误, 建议返回检查', 'ask', true, function () {
        //                                 resolve([]);
        //                             }, function () {
        //                                 heimaCheckService.markHeimaWordCompare($scope);
        //                                 messagePublishService.publish('trsCheck', {
        //                                     isTrsCheck: true,
        //                                     heimaInfo: data.heimaWords
        //                                 });
        //                                 reject([]);
        //                             }, 500, '返回查看', '仍要保存');
        //                         } else {
        //                             messagePublishService.publish('trsCheck', {
        //                                 isTrsCheck: false,
        //                                 heimaInfo: []
        //                             });
        //                             resolve([]);
        //                         }
        //                     }, () => {
        //                         resolve([]);
        //                     });
        //                 } else {
        //                     resolve([]);
        //                 }
        //             } else {
        //                 resolve([]);
        //             }
        //         }, () => {
        //             resolve([]);
        //         });
        //     });
        // }

        /**
         * [imgCheckForUeditor description]
         *
         * @param   {[type]}  $scope  [$scope description]
         *
         * @return  {[type]}          [return description]
         */
        function imgCheckForUeditor($scope) {
            return new Promise((resolve, reject) => {
                if (window.UE) {
                    const mediaType = editingCenterService.getEditPageMediaType();
                    const mediaName = editingCenterService.getMediaName(mediaType);
                    const ue = window.UE.getEditor('ueditor');
                    let HTMLContent = ue.getContent();
                    if (mediaName === '微信') {
                        if (HTMLContent.indexOf('images/video_default.png') > -1 || HTMLContent.indexOf('picture_default.jpg') > -1 || HTMLContent.indexOf('static/audio_default.jpg') > -1 || HTMLContent.indexOf('static/download_fail.png') > -1 || HTMLContent.indexOf('static/jz.gif') > -1) {
                            modalDialog.alertType('', '正文中有不符合发布要求的音视频或未成功下载的图片，请删除或替换后再尝试保存', 'error', false);
                            reject();
                        } else {

                            if ($scope.list && $scope.list.HTMLCONTENT) {
                                let outLinkCheckResults = ueditorService.checkLinksForWeixin($scope.list.HTMLCONTENT);
                                if (outLinkCheckResults.ISSUCCESS === 'false') {
                                    outLinkCheckResults.REPORTS.forEach((item) => {
                                        let tmpURL = item.URL.replace(/&/gi, '&amp;');
                                        $scope.list.HTMLCONTENT = $scope.list.HTMLCONTENT.replace(item.URL, '');
                                        $scope.list.HTMLCONTENT = $scope.list.HTMLCONTENT.replace(tmpURL, '');
                                    });
                                    ue.setContent($scope.list.HTMLCONTENT);
                                    modalDialog.multiReportsAlert(outLinkCheckResults);
                                    resolve();
                                }
                            }
                            resolve();
                        }
                    } else {
                        if (HTMLContent.indexOf('picture_default.jpg') > -1 || HTMLContent.indexOf('static/download_fail.png') > -1 || HTMLContent.indexOf('static/jz.gif') > -1) {
                            modalDialog.alertType('', '正文中有不符合发布要求或未成功下载的图片，请删除或替换后再尝试保存', 'error', false);
                            reject();
                        } else {
                            resolve();
                        }
                    }
                } else {
                    resolve();
                }
            });
        }
    },
]);
